import { Path } from '@/types/global';
import { ProfileStatusLabel } from '@/types/turn-enums';
import { FCRAWorkerAdverse } from '@/types/turn-api';

export const path = (path: Path<FCRAWorkerAdverse.Details>) => path;

export const STATUS_COLOR_MAP: Record<FCRAWorkerAdverse.AdverseActionStatus, string> = {
  pending_first_notice: 'turn_warning',
  pending_second_notice: 'turn_orange',
  rejected: 'turn_error',
};

export const STATUS_VALUE_MAP: Record<FCRAWorkerAdverse.AdverseActionStatus, ProfileStatusLabel> = {
  pending_first_notice: ProfileStatusLabel.FirstNotice,
  pending_second_notice: ProfileStatusLabel.SecondNotice,
  rejected: ProfileStatusLabel.Rejected,
};
